import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./order_list";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));
